import { tw } from "@careinfo/tailwind";
import { useContext, useEffect, useRef, useState } from "react";
import { NotificationContext } from "./context";
import { NotificationPanel } from "./Pannel";

export default function NotificationSideBar() {
  const { unreadCount, resetNotifications, showPannel, setShowPannel } =
    useContext(NotificationContext);

  const pannelRef = useRef<HTMLDivElement | null>(null);
  const panelContentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const controller = new AbortController();

    if (showPannel) {
      const handleClickOutside = (e: MouseEvent) => {
        const target = e.target as Node;
        const clickedOutside =
          pannelRef.current &&
          !pannelRef.current.contains(target) &&
          panelContentRef.current &&
          !panelContentRef.current.contains(target);

        if (clickedOutside) {
          setShowPannel(false);
        }
      };

      document.addEventListener("click", handleClickOutside, {
        signal: controller.signal,
      });

      document.body.classList.add(tw`overflow-hidden`);
    } else {
      controller.abort();
      setTimeout(() => {
        resetNotifications();
        document.body.classList.remove(tw`overflow-hidden`);
      }, 200);
    }

    return () => {
      controller.abort();
    };
  }, [showPannel]);

  return (
    <div className={tw`max-w-sm px-4`} ref={pannelRef}>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setShowPannel(!showPannel);
        }}
        className={tw`text-white group inline-flex items-center rounded-md px-3 py-2 text-base font-medium hover:text-white focus:outline-none relative`}
      >
        <span
          className={tw`absolute right-0 text-red-700 font-bold -top-1 px-2 bg-white rounded-full`}
        >
          {unreadCount}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={"white"}
          className={tw`w-6 h-6`}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
          />
        </svg>
      </button>
      <NotificationPanel
        setShowPannel={setShowPannel}
        showPannel={showPannel}
        panelRef={panelContentRef}
      />
    </div>
  );
}
